

































import { Component } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import { modalShelfDiagramStore } from '@/store'
import { SystemCode } from '@/api'

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalShelfDiagram extends ComponentVue {
  isError = false

  get isOpen(): boolean {
    return modalShelfDiagramStore.isOpen
  }

  get shelfType(): SystemCode {
    return modalShelfDiagramStore.shelfType
  }

  get holdingBranch(): SystemCode {
    return modalShelfDiagramStore.holdingBranch
  }

  get imagePath(): string {
    const path = `/images/shelf-diagram/${this.holdingBranch.code}${this.shelfType.code}`

    if (this.checkPath(path + '.jpg') === 200) {
      return path + '.jpg'
    }

    if (this.checkPath(path + '.gif') === 200) {
      return path + '.gif'
    }

    return path + '.png'
  }

  onError() {
    this.isError = true
  }

  onClickOk() {
    this.isError = false
    modalShelfDiagramStore.close()
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-shelf-diagram')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  checkPath(path: string) {
    const xhr = new XMLHttpRequest()
    xhr.open('HEAD', path, false)
    xhr.send(null)
    return xhr.status
  }
}
